import { render, staticRenderFns } from "./CCStatus.vue?vue&type=template&id=20325832&scoped=true"
import script from "./CCStatus.vue?vue&type=script&lang=js"
export * from "./CCStatus.vue?vue&type=script&lang=js"
import style0 from "./CCStatus.vue?vue&type=style&index=0&id=20325832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20325832",
  null
  
)

export default component.exports